export const DEFAULT_LANGUAGE_CODE = "en";

export const LANGUAGE_CATALOG = Object.freeze([
  { code: "en", label: "English", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "af", label: "Afrikaans", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ar", label: "Arabic", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: true },
  { code: "bn", label: "Bengali", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "de", label: "German", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "es", label: "Spanish", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "fr", label: "French", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "gu", label: "Gujarati", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "hi", label: "Hindi", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "id", label: "Indonesian", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "it", label: "Italian", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ja", label: "Japanese", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "kn", label: "Kannada", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ko", label: "Korean", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ml", label: "Malayalam", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "mr", label: "Marathi", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ms", label: "Malay", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "nl", label: "Dutch", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "or", label: "Odia", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "pa", label: "Punjabi", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "pt-BR", label: "Portuguese (Brazil)", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ru", label: "Russian", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "sw", label: "Swahili", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ta", label: "Tamil", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "te", label: "Telugu", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "tr", label: "Turkish", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "ur", label: "Urdu", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: true, rtl: true },
  { code: "vi", label: "Vietnamese", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "xh", label: "Xhosa", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: false, rtl: false },
  { code: "zh-Hans", label: "Chinese (Simplified)", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "zh-Hant", label: "Chinese (Traditional)", uiSupported: false, summaryTranslationSupported: true, transcriptionSupported: true, rtl: false },
  { code: "zu", label: "Zulu", uiSupported: true, summaryTranslationSupported: true, transcriptionSupported: false, rtl: false },
]);

export const COUNTRY_LANGUAGE_MAP = Object.freeze({
  AE: ["ar", "en", "ur", "hi"],
  AR: ["es", "en"],
  AT: ["de", "en"],
  AU: ["en"],
  BD: ["bn", "en"],
  BE: ["nl", "fr", "de", "en"],
  BR: ["pt-BR", "en"],
  CA: ["en", "fr"],
  CH: ["de", "fr", "it", "en"],
  CL: ["es", "en"],
  CN: ["zh-Hans", "en"],
  CO: ["es", "en"],
  CZ: ["en", "de"],
  DE: ["de", "en"],
  DK: ["en", "de"],
  EG: ["ar", "en"],
  ES: ["es", "en"],
  FI: ["en", "sv"],
  FR: ["fr", "en"],
  GB: ["en"],
  GH: ["en"],
  GR: ["en"],
  HK: ["zh-Hant", "en"],
  HU: ["en", "de"],
  ID: ["id", "en"],
  IE: ["en"],
  IL: ["en", "ar"],
  IN: ["hi", "bn", "mr", "te", "ta", "gu", "ur", "kn", "or", "ml", "pa", "en"],
  IT: ["it", "en"],
  JP: ["ja", "en"],
  KE: ["en", "sw"],
  KR: ["ko", "en"],
  LK: ["ta", "en"],
  MX: ["es", "en"],
  MY: ["ms", "en", "zh-Hans", "ta"],
  NG: ["en"],
  NL: ["nl", "en"],
  NO: ["en"],
  NP: ["hi", "en"],
  NZ: ["en"],
  PE: ["es", "en"],
  PH: ["en"],
  PL: ["en", "de"],
  PK: ["ur", "en"],
  PT: ["en", "pt-BR"],
  RO: ["en"],
  RU: ["ru", "en"],
  SA: ["ar", "en", "ur"],
  SE: ["en"],
  SG: ["en", "zh-Hans", "ms", "ta"],
  SK: ["en"],
  TH: ["en"],
  TR: ["tr", "en"],
  TW: ["zh-Hant", "en"],
  TZ: ["sw", "en"],
  UA: ["en"],
  UG: ["en", "sw"],
  US: ["en", "es"],
  VN: ["vi", "en"],
  ZA: ["en", "af", "zu", "xh"],
});

function normalizeBcp47(value = "") {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }
  const parts = raw.replaceAll("_", "-").split("-");
  return parts
    .map((part, index) => {
      const cleaned = part.replace(/[^a-z0-9]/gi, "");
      if (!cleaned) {
        return "";
      }
      if (index === 0) {
        return cleaned.toLowerCase();
      }
      if (cleaned.length === 2) {
        return cleaned.toUpperCase();
      }
      return `${cleaned.slice(0, 1).toUpperCase()}${cleaned.slice(1).toLowerCase()}`;
    })
    .filter(Boolean)
    .join("-");
}

export function normalizeLanguageCode(value, fallback = DEFAULT_LANGUAGE_CODE) {
  const normalized = normalizeBcp47(value);
  const direct = LANGUAGE_CATALOG.find((language) => language.code === normalized);
  if (direct) {
    return direct.code;
  }
  const base = normalized.split("-", 1)[0];
  const baseMatch = LANGUAGE_CATALOG.find((language) => language.code === base);
  return baseMatch?.code || fallback;
}

export function isUiLanguageCode(value) {
  const normalized = normalizeLanguageCode(value, "");
  return Boolean(
    normalized
    && LANGUAGE_CATALOG.some((language) => language.uiSupported && language.code === normalized)
  );
}

export function normalizeUiLanguageCode(value, fallback = DEFAULT_LANGUAGE_CODE) {
  const normalized = normalizeLanguageCode(value, "");
  if (normalized && isUiLanguageCode(normalized)) {
    return normalized;
  }
  if (fallback === "") {
    return "";
  }
  const normalizedFallback = normalizeLanguageCode(fallback, "");
  if (normalizedFallback && isUiLanguageCode(normalizedFallback)) {
    return normalizedFallback;
  }
  return DEFAULT_LANGUAGE_CODE;
}

export function resolveFirstUiLanguageCode(candidates = [], fallback = DEFAULT_LANGUAGE_CODE) {
  for (const candidate of candidates) {
    const normalized = normalizeUiLanguageCode(candidate, "");
    if (normalized) {
      return normalized;
    }
  }
  return normalizeUiLanguageCode(fallback);
}

export function resolveInitialLocale(initialLocale = "", storedLocale = "") {
  const normalizedInitialLocale = normalizeUiLanguageCode(initialLocale, "");
  if (normalizedInitialLocale) {
    return normalizedInitialLocale;
  }
  return normalizeUiLanguageCode(storedLocale || "", DEFAULT_LANGUAGE_CODE);
}

export function resolveRouteUiLanguageCode(pathname = "", fallback = "") {
  const rawPathname = String(pathname || "").trim();
  const match = rawPathname.match(/^\/l\/([^/?#]+)/);
  if (!match) {
    return "";
  }
  const encodedLocale = String(match[1] || "").trim();
  if (!encodedLocale) {
    return "";
  }
  try {
    return normalizeUiLanguageCode(decodeURIComponent(encodedLocale), fallback);
  } catch {
    return normalizeUiLanguageCode(encodedLocale, fallback);
  }
}

export function getLanguageByCode(value) {
  const normalized = normalizeLanguageCode(value);
  return LANGUAGE_CATALOG.find((language) => language.code === normalized) || LANGUAGE_CATALOG[0];
}

export function getLanguageLabel(value) {
  return getLanguageByCode(value).label;
}

const LANGUAGE_FLAG_COUNTRY_BY_CODE = Object.freeze({
  en: "GB",
  af: "ZA",
  xh: "ZA",
  zu: "ZA",
  bn: "IN",
  gu: "IN",
  hi: "IN",
  kn: "IN",
  ml: "IN",
  mr: "IN",
  or: "IN",
  pa: "IN",
  ta: "IN",
  te: "IN",
  ur: "PK",
});

function countryCodeToFlagEmoji(countryCode = "") {
  const normalized = String(countryCode || "").trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) {
    return "";
  }
  return Array.from(normalized)
    .map((letter) => 0x1f1e6 + letter.charCodeAt(0) - 65)
    .map((codePoint) => String.fromCodePoint(codePoint))
    .join("");
}

export function getLanguageFlag(value) {
  const normalized = normalizeLanguageCode(value, "");
  return countryCodeToFlagEmoji(LANGUAGE_FLAG_COUNTRY_BY_CODE[normalized] || "UN");
}

export function getLanguageCompactLabel(value) {
  const normalized = normalizeLanguageCode(value, "");
  if (!normalized) {
    return "";
  }
  return normalized.split("-", 1)[0].toUpperCase();
}

export function getUiLanguageCatalog() {
  return LANGUAGE_CATALOG.filter((language) => language.uiSupported);
}

function getLanguageCatalogForOptions({ uiOnly = false } = {}) {
  return uiOnly ? getUiLanguageCatalog() : LANGUAGE_CATALOG;
}

export function buildAlphabeticalLanguageSelectOptions({ uiOnly = false } = {}) {
  return [...getLanguageCatalogForOptions({ uiOnly })]
    .sort((left, right) => left.label.localeCompare(right.label));
}

export function buildLanguageQuickPickOptions({
  usedLanguageCodes = [],
  uiOnly = false,
} = {}) {
  const catalog = getLanguageCatalogForOptions({ uiOnly });
  const catalogByCode = new Map(catalog.map((language) => [language.code, language]));
  const ordered = [];
  const seen = new Set();
  const push = (value) => {
    const normalized = normalizeLanguageCode(value, "");
    if (!normalized || seen.has(normalized)) {
      return;
    }
    const language = catalogByCode.get(normalized);
    if (!language) {
      return;
    }
    seen.add(normalized);
    ordered.push(language);
  };

  push(DEFAULT_LANGUAGE_CODE);
  for (const languageCode of usedLanguageCodes) {
    push(languageCode);
  }
  return ordered;
}

export function resolveSuggestedUiLanguageCode({
  shareLinkEntry = null,
  runtimeConfig = null,
  browserLanguages = [],
  shareLinkCapturePending = false,
} = {}) {
  if (shareLinkCapturePending) {
    return "";
  }
  const shareLinkLanguageCode = shareLinkEntry?.uiLanguageHintCode
    || shareLinkEntry?.deliveryLanguageCode
    || "";
  const runtimeSuggestion = Array.isArray(runtimeConfig?.countryLanguageSuggestions)
    ? runtimeConfig.countryLanguageSuggestions[0]
    : "";
  return resolveFirstUiLanguageCode(
    [shareLinkLanguageCode, runtimeSuggestion, ...browserLanguages],
    DEFAULT_LANGUAGE_CODE,
  );
}

export function resolveSuggestedUiLanguageSource({
  shareLinkEntry = null,
  runtimeConfig = null,
} = {}) {
  if (shareLinkEntry?.uiLanguageHintCode || shareLinkEntry?.deliveryLanguageCode) {
    return "share_link";
  }
  if (Array.isArray(runtimeConfig?.countryLanguageSuggestions) && runtimeConfig.countryLanguageSuggestions[0]) {
    return "country_hint";
  }
  return "browser_locale";
}

export function buildLanguageSuggestions({
  countryCode = "",
  browserLanguages = [],
  shareLinkLanguageCode = "",
  preferredUiLanguageCode = "",
} = {}) {
  const ordered = [];
  const seen = new Set();
  const push = (value) => {
    const normalized = normalizeLanguageCode(value, "");
    if (!normalized || seen.has(normalized)) {
      return;
    }
    seen.add(normalized);
    ordered.push(normalized);
  };

  push(preferredUiLanguageCode);
  push(shareLinkLanguageCode);
  for (const languageCode of COUNTRY_LANGUAGE_MAP[String(countryCode || "").trim().toUpperCase()] || []) {
    push(languageCode);
  }
  for (const browserLanguage of browserLanguages) {
    push(browserLanguage);
  }
  push(DEFAULT_LANGUAGE_CODE);

  return ordered;
}

export function buildLanguageSelectOptions({
  countryCode = "",
  browserLanguages = [],
  shareLinkLanguageCode = "",
  preferredUiLanguageCode = "",
  uiOnly = false,
} = {}) {
  const prioritized = buildLanguageSuggestions({
    countryCode,
    browserLanguages,
    shareLinkLanguageCode,
    preferredUiLanguageCode,
  });
  const allowedCatalog = getLanguageCatalogForOptions({ uiOnly });
  const prioritizedSet = new Set(prioritized);
  const pinnedEnglish = getLanguageByCode(DEFAULT_LANGUAGE_CODE);
  const prioritizedOptions = prioritized
    .map((code) => allowedCatalog.find((language) => language.code === code))
    .filter(Boolean);
  const remainingOptions = allowedCatalog
    .filter((language) => !prioritizedSet.has(language.code) && language.code !== DEFAULT_LANGUAGE_CODE)
    .sort((left, right) => left.label.localeCompare(right.label));
  return [pinnedEnglish, ...prioritizedOptions.filter((language) => language.code !== DEFAULT_LANGUAGE_CODE), ...remainingOptions];
}

export function groupLanguagePreferences(profile = {}) {
  const languagePreferences = profile?.languagePreferences && typeof profile.languagePreferences === "object"
    ? profile.languagePreferences
    : {};
  const home = Array.isArray(languagePreferences.home)
    ? languagePreferences.home
    : [];
  const understands = Array.isArray(languagePreferences.understands)
    ? languagePreferences.understands
    : [];
  return {
    homeLanguageCode: normalizeLanguageCode(
      languagePreferences.homeLanguageCode || home[0]?.languageCode || "",
      "",
    ),
    understoodLanguageCodes: understands
      .map((item) => normalizeLanguageCode(item?.languageCode || item, ""))
      .filter(Boolean),
  };
}
